export class ManpowerMetricExclusion {
    id!: string
    job!: string
    jobDescription!: string
    jobDisplay!: string
    reason!: string
    effectiveOn!: string | Date | null
    archived!: boolean
    excluded!: boolean
    hasExclusion!: boolean
    estimatedHours!: number
    projectedHours!: number
    percentOverBid!: number
    pointsAdded!: number
    suggested!: boolean
    createdByUserId!: string | null
    createdOn!: string | null
}
